export const setProductCategory = (value, page, limit, totalCategories) => {
    return {
      type: 'SET_PRODUCT_CATEGORY',
      payload: { data: value, page, limit, totalCategories }
    };
  };